module.exports = __webpack_public_path__ + "02b0f0663ac6f7e410389caf1eae01f9.jpg";